import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

import '../styles/RegistroHogar.css';
// Carga dinámica de planes.json

const DEFAULT_API = process.env.REACT_APP_API_URL || '/api/ventas';

export default function RegistroHogar({ apiUrl = DEFAULT_API }) {
  const { userProfile } = useAuth();
  // Estado para los planes
  const [planesData, setPlanesData] = useState(null);
  const [form, setForm] = useState({
    agenteId: '',
    ordenSimo: '',
    cedulaCliente: '',
    customerName: '',
    plan: '',
    planPrice: '',
    homeNumber: ''
  });

  // Cargar planes.json dinámicamente
  useEffect(() => {
    const url = process.env.PUBLIC_URL + '/data/planes.json';
    console.log('Intentando cargar:', url);
    fetch(url)
      .then(res => {
        if (!res.ok) {
          console.error('Error al cargar planes.json:', res.status, res.statusText);
          return null;
        }
        return res.json();
      })
      .then(data => {
        if (!data) return;
        console.log('planesData cargado:', data);
        setPlanesData(data);
        // Inicializar el formulario con el primer plan disponible
        const grupos = Object.values(data.plansHome);
        const allPlans = grupos.flatMap(g => g.planes);
        if (allPlans.length > 0) {
          setForm(prev => ({
            ...prev,
            plan: allPlans[0].nombre,
            planPrice: allPlans[0].precio.toString()
          }));
        }
      })
      .catch(err => {
        console.error('Error de red o parseo al cargar planes.json:', err);
      });
  }, []);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  // Auto-cargar el Agente ID cuando el usuario se autentica
  useEffect(() => {
    if (userProfile?.agenteId) {
      setForm(prev => ({
        ...prev,
        agenteId: userProfile.agenteId
      }));
    }
  }, [userProfile]);

  function update(field, value) {
    const updatedForm = { ...form, [field]: value };
    // Si se cambió el plan, buscar el precio en los datos cargados
    if (field === 'plan' && planesData) {
      const grupos = Object.values(planesData.plansHome);
      const allPlans = grupos.flatMap(g => g.planes);
      const found = allPlans.find(p => p.nombre === value);
      updatedForm.planPrice = found ? found.precio.toString() : '';
    }
    setForm(updatedForm);
  }
    


  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    setResult(null);

    // Validación
    if (!form.agenteId) {
      setResult({ error: 'El ID del agente es requerido.' });
      setLoading(false);
      return;
    }
    if (!form.ordenSimo) {
      setResult({ error: 'El número de orden Simo es requerido.' });
      setLoading(false);
      return;
    }
    if (!form.cedulaCliente) {
      setResult({ error: 'La cédula del cliente es requerida.' });
      setLoading(false);
      return;
    }
    if (!form.customerName) {
      setResult({ error: 'El nombre del cliente es requerido.' });
      setLoading(false);
      return;
    }

    try {
      // Preparar datos para enviar
      const payload = {
        agenteId: form.agenteId,
        tipoPedido: 'hogar',
        numeroPedido: null,      // Hogar no usa numeroPedido
        plan: form.plan,
        planPrice: form.planPrice ? parseInt(form.planPrice) : null,
        cedulaCliente: form.cedulaCliente,
        customerName: form.customerName,
        homeNumber: form.ordenSimo,  // La orden Simo va en homeNumber
        imei: null,
        accesorioSerie: null,
        numeroCliente: null
      };

      const resp = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await resp.json();
      if (!resp.ok) throw data;

      setResult({ 
        success: true,
        message: `✅ Venta hogar registrada exitosamente`,
        docId: data.id
      });

      // Limpiar formulario
      setForm({
        agenteId: form.agenteId,  // Mantener el agente para próximas ventas
        ordenSimo: '',
        cedulaCliente: '',
        customerName: '',
        plan: PLANES_HOGAR[0],
        planPrice: '',
        homeNumber: '',
      });
    } catch (err) {
      setResult({ error: err.error || JSON.stringify(err) });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="registro-hogar-container">
      <div className="registro-hogar-header">
        <h2>📱 Registro de Ventas Hogar</h2>
        <p>Registra nuevas ventas de servicios hogar desde el sistema Simo</p>
      </div>

      <form onSubmit={submit} className="hogar-form-wrapper">
        
        <div className="hogar-form-group">
          <label className="hogar-required">Agente</label>
          <input 
            type="text"
            value={userProfile?.nombre || 'Cargando...'} 
            readOnly
            placeholder="ej: agente_001"
            style={{ backgroundColor: '#f0f0f0', cursor: 'not-allowed', color: '#666' }}
          />
        </div>

        <div className="hogar-form-group">
          <label className="hogar-required">Número de Orden Simo (ej: 33620704)</label>
          <input 
            type="text"
            value={form.ordenSimo} 
            onChange={e => update('ordenSimo', e.target.value)}
            placeholder="Ej: 33620704"
          />
        </div>

        <div className="hogar-form-group">
          <label className="hogar-required">Cédula del Cliente</label>
          <input 
            type="text"
            value={form.cedulaCliente} 
            onChange={e => update('cedulaCliente', e.target.value)}
            placeholder="ej: 123456789"
          />
        </div>

        <div className="hogar-form-group">
          <label className="hogar-required">Nombre del Cliente</label>
          <input 
            type="text"
            value={form.customerName} 
            onChange={e => update('customerName', e.target.value)}
            placeholder="ej: Juan Pérez García"
          />
        </div>

        <div className="hogar-form-group">
          <label>Plan de Hogar (Velocidad)</label>
          <select 
            value={form.plan} 
            onChange={e => update('plan', e.target.value)}
            style={{ fontSize: 14, fontWeight: 500 }}
          >
            {planesData && Object.values(planesData.plansHome).map(grupo => (
              <optgroup key={grupo.grupo} label={grupo.grupo}>
                {grupo.planes.map(plan => (
                  <option key={plan.id} value={plan.nombre}>{plan.nombre}</option>
                ))}
              </optgroup>
            ))}
          </select>
          <div style={{ fontSize: 13, color: '#34c759', fontWeight: 600, marginTop: 6 }}>
            Precio: ₡{form.planPrice ? parseInt(form.planPrice).toLocaleString() : '0'}
          </div>
        </div>

        <div className="hogar-form-group">
          <label style={{ opacity: 0.6 }}>Precio del Plan (se autocarga)</label>
          <input 
            type="text"
            value={form.planPrice ? `₡${parseInt(form.planPrice).toLocaleString()}` : ''} 
            readOnly 
            style={{ backgroundColor: '#f0f0f0', cursor: 'not-allowed' }}
            placeholder="Se autocarga al seleccionar plan"
          />
        </div>

        <div className="hogar-form-group">
          <label>Número de Teléfono Hogar (opcional)</label>
          <input 
            type="text"
            value={form.homeNumber} 
            onChange={e => update('homeNumber', e.target.value)}
            placeholder="ej: 22123456"
          />
        </div>
                
        {/* Renovación no aplica en formulario Hogar */}

        <button 
          type="submit" 
          disabled={loading}
          className="hogar-form-button"
        >
          {loading ? 'Registrando...' : 'Registrar Venta Hogar'}
        </button>
      </form>

      {result && (
        <div className={`hogar-result ${result.error ? 'error' : 'success'}`}>
          {result.error && <strong>❌ Error:</strong>}
          {result.success && <strong>✅ Éxito:</strong>}
          <p style={{ marginTop: 8 }}>
            {result.error || result.message}
          </p>
          {result.docId && (
            <p className="hogar-result-doc-id">
              ID de documento: {result.docId}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
